import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import type {
  PostCompanyReviewInput,
  PostCompanyReviewPayload,
} from '@seek/ca-graphql-schema/types';

import { POST_COMPANY_REVIEW_MUTATE } from './graphqlQueries';
import type { Logger } from '@seek/logger';

export type CompanyReviewService = ReturnType<
  typeof createCompanyReviewService
>;

export const createCompanyReviewService = ({
  client,
  logger,
}: {
  client: ApolloClient<NormalizedCacheObject>;
  logger: Logger;
}) => {
  const submitReview = async (
    input: PostCompanyReviewInput,
  ): Promise<PostCompanyReviewPayload | undefined> => {
    const variables = {
      input,
    };
    const response = await client.mutate<{
      postCompanyReview: PostCompanyReviewPayload;
    }>({
      mutation: POST_COMPANY_REVIEW_MUTATE,
      variables,
    });

    if (response?.errors) {
      logger.error(
        { error: response.errors, variables },
        'Error calling submitReview',
      );
    }

    return response?.data?.postCompanyReview;
  };

  return {
    submitReview,
  };
};
